export default "__VITE_ASSET__CTdX0vtF__"